import {SxProps} from '@mui/material';

export const STYLES = {
  container: {
    position: 'relative',
    width: '34px',
    height: '14px',
  },
  title: {
    height: '19px',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
  },
  switch: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
} as const satisfies SxProps;
